// extracted by mini-css-extract-plugin
export default {"container":"NewsMiniPreview_container__PQN8M","thumbImg":"NewsMiniPreview_thumbImg__uiNf5"};